import { Injectable } from '@angular/core';
import { lang } from '../lang/lang.nl';
import { ProjectGetModel, ProjectModel } from '../models/projects/project.model';
import { GridViewModel } from '../models/ui/grid-view.model';
import { EmployeeModel } from '../models/users/user.model';
import {AccessControlService} from "../../core/access-control/access-control.service";
import {employeeRole} from "../../core/access-roles/employee.role";
import {adminRole} from "../../core/access-roles/admin.role";

@Injectable({
  providedIn: 'root'
})
export class DataHelperService {
  constructor(private _accessControl: AccessControlService) { }

  /**
   * @param  {ProjectModel[]} data
   * @returns GridViewModel
   */
  configureProjectDataGrid(data: ProjectGetModel, status): GridViewModel[] {
    let returnData: GridViewModel[] = [];
    let project_btn_menu = [];
    let project_btn_primary = [];
    if (status === 'active') {
      project_btn_menu = [
      { title: lang.projects.globe, icon: 'globe' },
      { title: lang.common.file, icon: 'file-text' },
      { title: lang.common.edit, icon: 'edit' },
      { title: lang.common.check, icon: 'check-square' },
      { title: lang.common.delete, icon: 'trash-2' },
    ]
    project_btn_primary = [
      { title: lang.projects.viewProjectPage, icon: 'eye' }
    ]
    } else {
      project_btn_menu = [
        { title: lang.common.check, icon: 'check-square' },
      ]
      project_btn_primary = [

      ]
  }
    data.projects.forEach(element => {
      let gridView: GridViewModel = {
        status: element.activeState,
        title: element.name,
        _id: element._id,
        list: [
          { icon: 'briefcase', data: element.number, title: 'Projectnummer' },
          { icon: 'home', data: element.address, title: 'Adres' },
          { icon: 'plus', data: element.extras === null ? '-' : element.extras, title: 'Notities' }
        ],
        secondaryButtonGroup: project_btn_menu,
        primaryButtonGroup: project_btn_primary,
      }

      if (!this._accessControl.getAccessValue('project', 'others')) {
        gridView.secondaryButtonGroup = [];
      }
      if (status === 'active') {
        if ( this._accessControl.getRoleCode() === employeeRole.code ){
          gridView.secondaryButtonGroup.find(element => (element.icon === 'edit')).class='d-none';
          gridView.secondaryButtonGroup.find(element => (element.icon === 'trash-2')).class='d-none';
          gridView.secondaryButtonGroup.find(element => (element.icon === 'check-square')).class='d-none';
        }else if (this._accessControl.getRoleCode() === adminRole.code){
          gridView.secondaryButtonGroup.find(element => (element.icon === 'trash-2')).class='d-none';
       }
      }
      returnData.push(gridView);
    })
    return returnData;
  }
  public configureProjectList(data: ProjectGetModel) {
    return data.projects.map(ele => {
      return {
        name: ele.name,
        address: ele.address,
        number: ele.number,
        extras: ele.extras,
        activeState: ele.activeState,
        _id: ele._id
      }
    });
  }

  configureSealsDataGrid(data): GridViewModel[] {
    let returnData: GridViewModel[] = [];
    let project_btn_menu = [];
    let project_btn_primary = [];

    project_btn_primary = [
      { title: lang.common.info, icon: 'info' }
    ]

    data.forEach(element => {
      let gridView = {
        status: element.activeState,
        title: element.code,
        _id: element._id,
        list: [
          { icon: 'codesandbox', data: element.qrCode !== null? element.qrCode : 'N/A', title: 'QR Code' },
          { icon: 'tool',
            data: element.status.nameDutch === 'voldoet'
          ? 'Voldoet'
          : element.status.nameDutch === 'voldoet, mits'
            ? 'Voldoet, mits'
            : element.status.nameDutch === 'voldoet niet'
              ? 'Voldoet niet'
              : element.status.nameDutch === 'foutieve invoer'
                ? 'Foutieve invoer'
                : element.status.nameDutch === 'derde partij'
                  ? 'Derde partij'
                  : '-',
             title: 'Status',
             style(value) {
              switch (value) {
                case 'Voldoet': {
                  return 'text-0';
                }
                case 'Voldoet, mits': {
                  return 'text-1';
                }
                case 'Voldoet niet': {
                  return 'text-2';
                }
                case 'Foutieve invoer': {
                  return 'text-3';
                }
                case 'Derde partij': {
                  return 'text-4';
                }
                default: {
                  return '';
                }
              }
            }

          }
        ],
        secondaryButtonGroup: project_btn_menu,
        primaryButtonGroup: project_btn_primary,
        img: element.pictures.length !== 0 ? element.pictures[element.pictures.length-1].image : ''
      }
      returnData.push(gridView);
    })
    return returnData;
  }

  public configureSealsList(data) {
    return data.map(ele => {
      return {
        code: ele.code,
        qrCode: ele.qrCode !== null? ele.qrCode : 'N/A',
        status: ele.status.nameDutch === 'voldoet'
        ? 'Voldoet'
        : ele.status.nameDutch === 'voldoet, mits'
          ? 'Voldoet, mits'
          : ele.status.nameDutch === 'voldoet niet'
            ? 'Voldoet niet'
            : ele.status.nameDutch === 'foutieve invoer'
              ? 'Foutieve invoer'
              : ele.status.nameDutch === 'derde partij'
                ? 'Derde partij'
                : '-',

        activeState: ele.activeState,
        _id: ele._id
      }
    });
  }



  public configureEmployeeList(data: EmployeeModel) {
    return data.users.map(ele => {
      return {
        name: ele.name,
        email: ele.username,
        role: ele.role.name.charAt(0).toUpperCase() + ele.role.name.slice(1),
        _id: ele._id
      }
    });
  }

  public configureEmployeeGrid(data: EmployeeModel, status) {
    let list = [];
    if (status === 'active') {
      list = [
        { title: lang.common.edit, icon: 'edit' },
        { title: lang.common.check, icon: 'check-square' },
        { title: lang.common.delete, icon: 'trash-2' },
      ]
    } else {
      list = [
        { title: lang.common.check, icon: 'check-square' },
        { title: lang.common.delete, icon: 'trash-2' },
      ]
    }
    return data.users.map(ele => {
      return {
        status: ele.activeState,
        title: ele.name,
        _id: ele._id,
        list: [
          { title: 'Email', icon: 'mail', data: ele.username },
          { title: 'Rol', icon: 'user', data: ele.role.name.charAt(0).toUpperCase() + ele.role.name.slice(1) }
        ],
        secondaryButtonGroup: list,
        primaryButtonGroup: [],
      }
    });
  }

  // ONLY DECIMAL VALUES ALLOWED
  checkIsDecimal(event) {
    const isShiftKey = event.shiftKey;
    const y = Number(event.key);
    const x = event.which || event.keycode;
    if (x === 32) {
      return false;
    } else if (!isNaN(y)) {
      return true;
    } else {
      if (x === 8 || x === 9 || (x >= 35 && x <= 40) || x === 46 || x === 110 || (x === 190 && !isShiftKey)) {
        return true;
      } else {
        return false;
      }
    }
  }


  checkIsNumber(event) {
    const isShiftKey = event.shiftKey;
    const y = Number(event.key);
    const x = event.which || event.keycode;
    if (x === 32) {
        return false;
    } else if (!isNaN(y)) {
        return true;
    } else {
        if (x === 8 || x === 9 || (x >= 35 && x <= 40) || x === 46) {
            return true;
        } else {
            return false;
        }
    }
}
}
